var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('Fokteven')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }